import React from 'react';
export const LineVertical = () => (React.createElement("div", { className: 'line line-vertical' },
    React.createElement("span", null),
    React.createElement("span", null)));
